import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,Select,InputLabel,FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Box,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { ToastContainer,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { useAuth } from "../../../AuthProvider";

import { ListItemIcon, Menu, MenuItem,ListItemText} from "@mui/material"; 
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';

function DriversList() {
  const [drivers, setDriversData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null); // To store the row to edit
  const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const navigate = useNavigate();
  const { oId ,userId,role,pId} = useAuth();
  const [dialogbtnloading, setDialogbtnloading] = useState(false); // State for loading

    const [driver, setDriver] = useState([]);
      const [attender, setAttender] = useState([]);
        const [teachers, setTeachers] = useState([]);

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const [exportAnchorEl, setExportAnchorEl] = useState(null);
      const isExportMenuOpen = Boolean(exportAnchorEl);
      
      const handleExportClick = (event) => {
        setExportAnchorEl(event.currentTarget);
      };
      
      const handleExportClose = () => {
        setExportAnchorEl(null);
      };



const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState('');
    const isPrincipal = role?.startsWith("PRINCIPAL") || false;
    const UserId = userId || selectedUsers;

  
       const fetchUsers = async () => {
           try {
               const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${pId}`);
               if (!response.ok) {
                   throw new Error('Failed to fetch users');
               }
               const data = await response.json();
               setUsers(data);
               if (data.length > 0) {
                 setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
             }
           } catch (error) {
               console.error('Error fetching users:', error);
           }
       };
    useEffect(() => {
    if (isPrincipal) {
        fetchUsers();
    }
}, []);


//Table get all  

const fetchData = async () => {
  if (!UserId) return;

  setLoading(true);
  try {
    const response = await fetch(`${baseUrl}/api/driver/getAll/${oId}/${UserId}`);

    if (!response.ok) {
      console.error("API returned an error status:", response.status);
      setDriversData([]); // fallback to empty array
      return;
    }

    const data = await response.json();
    console.log("API Response:", data);

    // Ensure data is an array before setting it
    if (Array.isArray(data)) {
      setDriversData(data);
    } else {
      console.warn("Unexpected response format:", data);
      setDriversData([]); // fallback
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    setDriversData([]); // fallback
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  fetchData();
}, [UserId]);



// Filter data based on searchQuery
const filteredResults = drivers.filter((item) => {
  const firstName = item.firstName ? item.firstName.toLowerCase() : "";
  const lastName = item.lastName ? item.lastName.toLowerCase() : "";
  const fullName = `${firstName} ${lastName}`; // Combine first and last names
  return fullName.includes(searchQuery.toLowerCase()); // Search in full name
});



  const handleAddNew = () => {
    navigate("/DriverRegForm");
  };

  const handleEditClick = (row) => {
    setSelectedRow(row); // Set the selected row
    setDialogOpen(true); // Open the dialog
  };



//     const fetchDrivers = async () => {
//       if(!UserId) return;
//       try {
//         const response = await fetch(`${baseUrl}/api/driver/getAllRolesIdsAndNames/byRole/${oId}/${pId}/${UserId}?role=DRIVER`);
//         if (!response.ok) {
//           // throw new Error("Failed to fetch employees");
//           console.log("Failed to fetch Drivers")
//         }
//         const data = await response.json();
//         setDriver(data);
//       } catch (error) {
//         console.error("Error fetching employees:", error);
//       }
//     };
 useEffect(() => {
    fetchDrivers();
  }, [UserId]);

const fetchDrivers = async () => {
  if (!UserId) return;

  try {
    const response = await fetch(`${baseUrl}/api/driver/getAllRolesIdsAndNames/byRole/${oId}/${pId}/${UserId}?role=DRIVER`);
    
    if (!response.ok) {
      console.error("Failed to fetch Drivers. Status:", response.status);
      return; // Exit early to avoid processing a bad response
    }

    const data = await response.json();
    
    // Optional: check if data is valid before setting state
    if (Array.isArray(data)) {
      setDriver(data);
    } else {
      console.warn("Unexpected response format:", data);
      setDriver([]); // Set to empty array or handle accordingly
    }

  } catch (error) {
    console.error("Error fetching drivers:", error);
    setDriver([]); // Safe fallback on error
  }
};



// const handleDriverChange = (event) => {
//   const selectedDriver = driver.find(
//     (emp) => emp.employeeId === event.target.value
//   );

//   if (selectedDriver) {
//     setSelectedRow((prevData) => ({
//       ...prevData,
//       firstName: selectedDriver.firstName || "",
//       lastName: selectedDriver.lastName || "",
//       employeeId: selectedDriver.employeeId || "",
//       driverMobile: selectedDriver.mobileNo || "",
//       driverEmail: selectedDriver.email || "",
//     }));
//   }
// };

const handleDriverChange = (event) => {
  const selectedDriverId = event.target.value;

  if (selectedDriverId === "") {
    // User chose the empty option -> clear driver fields
    setSelectedRow((prevData) => ({
      ...prevData,
      firstName: "",
      lastName: "",
      employeeId: "",
      driverMobile: "",
      driverEmail: "",
    }));
  } else {
    const selectedDriver = driver.find(
      (emp) => emp.employeeId === selectedDriverId
    );

    if (selectedDriver) {
      setSelectedRow((prevData) => ({
        ...prevData,
        firstName: selectedDriver.firstName || "",
        lastName: selectedDriver.lastName || "",
        employeeId: selectedDriver.employeeId || "",
        driverMobile: selectedDriver.mobileNo || "",
        driverEmail: selectedDriver.email || "",
      }));
    }
  }
};





  const fetchAttenders = async () => {
    if (!UserId) return;

    try {
      const response = await fetch(
        `${baseUrl}/api/driver/getAllRolesIdsAndNames/byRole/${oId}/${pId}/${UserId}?role=ATTENDER`
      );

      if (!response.ok) {
        console.error("Failed to fetch Attenders. Status:", response.status);
        setAttender([]); // Fallback to empty array
        return;
      }

      const data = await response.json();

      if (Array.isArray(data)) {
        setAttender(data);
      } else {
        console.warn("Unexpected Attender response format:", data);
        setAttender([]); // fallback to avoid crash
      }
    } catch (error) {
      console.error("Error fetching attenders:", error);
      setAttender([]); // fallback
    }
  };
useEffect(() => {
  fetchAttenders();
}, [UserId]);





//Teachers list api

  async function fetchTeachers() {
    try {
      const response = await fetch(`${baseUrl}/api/driver/getAllTeachersForDrivers/${oId}/TEACHER/${pId}`);
      if (response.ok) {
        const data = await response.json();
        setTeachers(data);
      } else {
        console.error("Failed to fetch teachers");
      }
    } catch (error) {
      console.error("Error fetching teachers", error);
    }
  }
  useEffect(() => {
  fetchTeachers();
}, [oId]);






// const handleSaveChanges = async () => {
//   console.log("Selected Row Data before update:", selectedRow);
//   setDialogbtnloading(true); // Start loading

//   try {
//     const formData = new FormData();

//     // ✅ Only these fields will be sent to the backend
//     const allowedFields = [
//       "drId",
//       "driversIds",
//       "firstName",
//       "lastName",
//       "busNumber",
//       "routeNumber",
//       "driverPickupLocation",
//       "driverDropLocation",
//       "attenderId",
//       "teacherId",
//     ];

//     allowedFields.forEach((key) => {
//       const value = selectedRow[key];
//       if (value !== "" && value !== null && value !== undefined) {
//         formData.append(key, value);
//       }
//     });

//     const response = await fetch(
//       `${baseUrl}/api/driver/update/${selectedRow.drId}/${oId}`,
//       {
//         method: "PATCH",
//         body: formData,
//       }
//     );

//     const responseData = await response.text();

//     if (!response.ok) {
//       throw new Error(responseData || "Failed to update the details.");
//     }

//     toast.success("Driver Details updated successfully!");
//     fetchData();
//     fetchDrivers();
//     fetchAttenders();
//     fetchTeachers();
//     handleDialogClose();
//   } catch (error) {
//     console.error("Error updating details:", error);
//     toast.error(`Error updating details: ${error.message}`);
//   } finally {
//     setDialogbtnloading(false); // Stop loading
//   }
// };


const handleSaveChanges = async () => {
  console.log("Selected Row Data before update:", selectedRow);
  setDialogbtnloading(true);

  try {
    const formData = new FormData();

    // ✅ Only allowed fields
    const allowedFields = [
      "drId",
      "employeeId",
      "firstName",
      "lastName",
      "busNumber",
      "routeNumber",
      "driverPickupLocation",
      "driverDropLocation",
      "attenderId",
      "teacherId",
    ];

    allowedFields.forEach((key) => {
      formData.append(key, selectedRow[key] || ""); // send empty string if not selected
    });

    const response = await fetch(
      `${baseUrl}/api/driver/update/${selectedRow.drId}/${oId}`,
      {
        method: "PATCH",
        body: formData,
      }
    );

    const responseData = await response.text();

    if (!response.ok) {
      throw new Error(responseData || "Failed to update the details.");
    }

    toast.success("Driver Details updated successfully!");
    fetchData();
    fetchDrivers();
    fetchAttenders();
    fetchTeachers();
    handleDialogClose();
  } catch (error) {
    console.error("Error updating details:", error);
    toast.error(`Error updating details: ${error.message}`);
  } finally {
    setDialogbtnloading(false);
  }
};


  const handleDeleteClick = async (row) => {
    if (!row.drId) {
      toast.error("Invalid row. Please select a valid row to delete.");
      return;
    }
  
    // Show SweetAlert2 confirmation
    Swal.fire({
      title: "Are you sure?",
      text: `You Want To Delete Driver ${row.firstName} ${row.lastName}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          console.log("Deleting row with ID:", row.drId);
          const response = await fetch(
            `${baseUrl}/api/driver/delete/${row.drId}/${oId}`,
            {
              method: "DELETE",
            }
          );
  
          if (!response.ok) {
            throw new Error("Failed to delete the row. Please try again.");
          }
  
          toast.success("Driver Deleted successfully!", {
            autoClose: 1000, // Closes after 1 second (1000ms)
          });
          fetchData();
          
  
          // // Remove the row from state after successful deletion
          // setFilteredData((prevData) =>
          //   prevData.filter((row) => row.id !== row.drId)
          // );
  
         
        } catch (error) {
          console.error("Error deleting row:", error);
          toast.error(`Error deleting row: ${error.message}`);
        }
      }
    });
  };
  
  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
    setSelectedRow(null); // Clear the selected row
  };





   
   // Export to Excel
   const exportToExcel = () => {
     const filteredData = filteredResults.map(({ 
      firstName,lastName, busNumber, routeNumber, 
      driverPickupLocation, driverDropLocation, driverMobile, attenderName,attendantMobile
     }) => ({
      Name:`${firstName} ${lastName}`,
       BusNumber: busNumber,
       RouteNumber: routeNumber,
       DriverPicLocation:driverPickupLocation,
       DriverDropLocation:driverDropLocation,
       DriverMobile: driverMobile,
       AttendantName:attenderName,
       AttendantMobile:attendantMobile
     }));
   
     const workbook = new ExcelJS.Workbook();
     const worksheet = workbook.addWorksheet("Drivers_List");
   
     // Add headers
     worksheet.columns = [
      { header: "Driver Name", key: "Name", width: 20 },
       { header: "Bus No", key: "BusNumber", width: 15 },
       { header: "Route No", key: "RouteNumber", width: 15 },
       { header: "DriverPicLocation", key: "DriverPicLocation", width: 20 },
       { header: "DriverDropLocation", key: "DriverDropLocation", width: 20 },
       { header: "Driver No", key: "DriverMobile", width: 15 },
       { header: "AttendantName", key: "AttendantName", width: 20 },
       { header: "Attendant No", key: "AttendantMobile", width: 15 },
     ];
   
    // Add data rows
    filteredData.forEach((data) => {
      worksheet.addRow(data);
    });
   
     // Style headers
     worksheet.getRow(1).eachCell((cell) => {
       cell.font = { bold: true };
       cell.alignment = { horizontal: "center" };
       cell.fill = {
         type: "pattern",
         pattern: "solid",
         fgColor: { argb: "87CEEB" }, // Light Blue Header
       };
     });
   
     // Write and download file
     workbook.xlsx.writeBuffer().then((buffer) => {
       const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
       const link = document.createElement("a");
       link.href = URL.createObjectURL(blob);
       link.download = `Drivers_List.xlsx`;
       link.click();
     });
   
     handleExportClose();
   };
   
   // Export to PDF
   const exportToPDF = () => {
     const doc = new jsPDF();
   
     // Title
     doc.setFontSize(16);
     doc.setFont("helvetica", "bold");
     doc.text("Drivers List", 10, 8);
   
     doc.setFontSize(10);
     doc.setFont("helvetica", "normal");
     doc.text("Generated On: ", 14, 16);
     doc.setFont("helvetica", "bold");
     doc.text(new Date().toLocaleDateString(), 40, 16);
   
     // Table
     doc.autoTable({
       startY: 20,
       head: [["S.No", "Name", "Bus No", "Route No", "Driver Pickup Location", "Driver Drop Location", "Driver No", "Attendant Name","Attendant No"]],
       body: filteredResults.map((row, index) => [
         index + 1,
         `${row.firstName} ${row.lastName}`,
         row.busNumber,
         row.routeNumber,
         row.driverPickupLocation,
         row.driverDropLocation,
         row.driverMobile,
         row.attenderName,
         row.attendantMobile
        
       ]),
       styles: {
         lineWidth: 0.2,
         lineColor: "#B6B9CD",
       },
       headStyles: {
         fillColor: [63, 81, 181],
         textColor: [255, 255, 255],
         halign: "center",
       },
       bodyStyles: {
         halign: "center",
       },
       theme: "grid",
     });
   
     doc.save("Drivers_List.pdf");
     handleExportClose();
   };
   
   
   // Export to JSON
   const exportToJSON = () => {
     const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
       JSON.stringify(filteredResults, null, 2)
     )}`;
     const link = document.createElement("a");
     link.href = jsonString;
     link.download = "Drivers_List.json";
     link.click();
     handleExportClose();
   };
   
  

  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <CardContent>
        {/* Title Section */}
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography
              variant="h4"
              style={{ fontWeight: "bold", color: "#333" }}
            >
              Driver And Attender Details
            </Typography>
          </Grid>
           <Button
    variant="contained"
    onClick={handleAddNew}
    sx={{
      backgroundColor: "#3C3972",
      color: "#fff",
      height: "40px",
      fontWeight:'bold',
      width: "100px", // Optional: Set a fixed width
      "&:hover": {
        backgroundColor: "#3C3972", // Slightly darker green on hover
      },
    }}
  >
    Add New
            </Button>
        </Grid>

        {/* Search and Add New Button Section */}
       
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          style={{ marginTop: "1px" }}
          marginBottom={3}
        >
          <Grid item xs={3}>
            <TextField
              fullWidth
              label="Search by  Name"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Grid>
            {/* {isPrincipal && (
                        <Grid item xs={6} >
                          <FormControl fullWidth size="small" style={{ width: "200px" }}>
                            <InputLabel>Select Transport Admin</InputLabel>
                            <Select
                              value={selectedUsers}
                              onChange={(e) => setSelectedUsers(e.target.value)}
                              label="Select Transport Admin"
                            >
                              {users.map((user) => (
                                <MenuItem key={user.userId} value={user.userId}>
                                  {user.userId} - {user.firstName} {user.lastName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      )} */}

          <Grid item xs={3} sx={{ display: "flex" ,justifyContent:"flex-end"}} gap={2}>
            

          <Button 
    variant="contained" 
    onClick={handleExportClick}  
    style={{ backgroundColor: '#3C3972', fontWeight: 'bold' }}
    startIcon={<PresentToAllIcon />}  
  >
    Export
  </Button>

  <Menu
    anchorEl={exportAnchorEl}
    open={isExportMenuOpen}
    onClose={handleExportClose}
    sx={{
      "& .MuiPaper-root": {
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
      },
    }}
  >
    <MenuItem 
      onClick={exportToExcel}
      sx={{
        color: "#3f51b5",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f0fe",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#00796b' }}>
        <SimCardDownloadIcon />
      </ListItemIcon>
      <ListItemText primary="Excel" sx={{ fontWeight: 'bold', color: '#00796b' }} />
    </MenuItem>
    
    <MenuItem 
      onClick={exportToPDF}
      sx={{
        color: "#d32f2f",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#fdecea",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#d32f2f' }}>
        <PictureAsPdfIcon />
      </ListItemIcon>
      <ListItemText primary="PDF" sx={{ fontWeight: 'bold', color: '#d32f2f' }} />
    </MenuItem>
    
    <MenuItem 
      onClick={exportToJSON}
      sx={{
        color: "#388e3c",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f5e9",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#6a1b9a' }}>
        <FilePresentIcon />
      </ListItemIcon>
      <ListItemText primary="JSON" sx={{ fontWeight: 'bold', color: '#6a1b9a' }} />
    </MenuItem>
  </Menu>



 
</Grid>

        </Grid>

        <GlobalStyles
          styles={{
            ".custom-sidebar-scrollbar": {
              scrollbarWidth: "thin", // For Firefox
              scrollbarColor: "grey #e0e0e0",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
              width: "6px", // For WebKit-based browsers
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
              background: "#f1f1f1", // Track color
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
              backgroundColor: "grey", // Thumb color
              borderRadius: "10px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        />
        {/* Table Section */}
        <TableContainer
  component={Paper}
  style={{
    marginTop: "20px",
    borderRadius: "8px",
    maxHeight: "400px",
    overflowY: "auto",
    // maxWidth: "950px",  // ✅ Reduced table width
    margin: "auto",   
  }}
  className="custom-sidebar-scrollbar"
>
  <Table stickyHeader>
    <TableHead>
      <TableRow sx={{ height: "30px" }}> {/* Reduced header row height */}
        <TableCell sx={{ minWidth: "50px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4", fontWeight:'bold',fontSize:'14px' }}>S.No</TableCell>
        <TableCell sx={{ minWidth: "120px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4", fontWeight:'bold' ,fontSize:'14px' }}>Driver Name</TableCell>
        {/* <TableCell sx={{ minWidth: "150px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" }}>Address</TableCell> */}
        {/* <TableCell sx={{ minWidth: "80px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" , fontWeight:'bold',fontSize:'14px' }}>Bus Id</TableCell> */}
        <TableCell sx={{ minWidth: "80px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" , fontWeight:'bold',fontSize:'14px' }}>Bus No</TableCell>
        {/* <TableCell sx={{ minWidth: "80px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" , fontWeight:'bold',fontSize:'14px' }}>Route No</TableCell> */}
        <TableCell sx={{ minWidth: "120px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" , fontWeight:'bold',fontSize:'14px' }}>Pickup Loc</TableCell>
        <TableCell sx={{ minWidth: "120px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" , fontWeight:'bold',fontSize:'14px' }}>Drop Loc</TableCell>
        <TableCell sx={{ minWidth: "100px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" , fontWeight:'bold',fontSize:'14px' }}>Driver No</TableCell>
        {/* <TableCell sx={{ minWidth: "120px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" }}>Driver Email</TableCell> */}
        <TableCell sx={{ minWidth: "120px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" , fontWeight:'bold',fontSize:'14px' }}>Attendant Name</TableCell>
         <TableCell sx={{ minWidth: "120px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" , fontWeight:'bold',fontSize:'14px' }}>Teacher Name</TableCell>
        {/* <TableCell sx={{ minWidth: "100px", borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" }}>Attendant Mobile</TableCell> */}
        <TableCell sx={{ minWidth: "100px", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" , fontWeight:'bold',fontSize:'14px' }}>Action</TableCell>
      </TableRow>
    </TableHead>

    <TableBody>
      {loading ? (
        <TableRow sx={{ height: "30px" }}>
         <TableCell colSpan={12} style={{ textAlign: "center", padding: "20px" }}>
                                          <Box display="flex" flexDirection="column" alignItems="center">
                                            <CircularProgress />
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                              Loading Data...
                                            </Typography>
                                          </Box>
                                        </TableCell>
        </TableRow>
      ) : filteredResults.length === 0 ? (
        <TableRow sx={{ height: "30px" }}>
          <TableCell colSpan={12} style={{ textAlign: "center" }}>
            No data found.
          </TableCell>
        </TableRow>
      ) : (
        filteredResults.map((row, index) => (
          <TableRow
            key={row.id}
            sx={{ height: "30px" }} // Reduced row height
            style={{
              backgroundColor: "white",
              transition: "background-color 0.3s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "white"; // Default color
            }}
          >
            <TableCell sx={{ minWidth: "50px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{index + 1}</TableCell>
            <TableCell sx={{ minWidth: "120px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}> {row.firstName && row.lastName ? `${row.firstName} ${row.lastName}`: "N/A"}</TableCell>
            {/* <TableCell sx={{ minWidth: "150px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.address}</TableCell> */}
            {/* <TableCell sx={{ minWidth: "80px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.busNumber}</TableCell> */}
            <TableCell sx={{ minWidth: "80px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.busNumberPlate}</TableCell>
            {/* <TableCell sx={{ minWidth: "80px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.routeNumber}</TableCell> */}
            <TableCell sx={{ minWidth: "120px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.driverPickupLocation}</TableCell>
            <TableCell sx={{ minWidth: "120px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.driverDropLocation}</TableCell>
            <TableCell sx={{ minWidth: "100px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.driverMobile || "N/A"}</TableCell>
            <TableCell sx={{ minWidth: "100px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.attenderName || "N/A"}</TableCell>
            <TableCell sx={{ minWidth: "100px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.teacherName || "N/A"}</TableCell>
            {/* <TableCell sx={{ minWidth: "120px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.driverEmail}</TableCell> */}
{/* <TableCell
  sx={{
    minWidth: "120px",
    textAlign: "center",
    borderRight: "1px solid #ddd",
    padding: "2px",
  }}
>
  {row.attenderName?.trim() && row.teacherName?.trim()
    ? `${row.attenderName.trim()}, ${row.teacherName.trim()}`
    : row.attenderName?.trim()
    ? row.attenderName.trim()
    : row.teacherName?.trim()
    ? row.teacherName.trim()
    : "N/A"}
</TableCell> */}

            {/* <TableCell sx={{ minWidth: "100px", textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.attendantMobile}</TableCell> */}
            <TableCell sx={{ minWidth: "100px", textAlign: "center", padding: "4px" }}>
              <Box
                                                                sx={{
                                                                  display: "flex",
                                                                  justifyContent: "center",
                                                                  gap: "4px",
                                                                }}
                                                              >
         
<Button
                                                    sx={{
                                                      backgroundColor: "#1565c0",
                                                      color: "white",
                                                      "&:hover": { backgroundColor: "#0d47a1" },
                                                      // borderRadius: 2,
                                                      padding: "2px 4px",
                                                    }}
                                                    onClick={() => handleEditClick(row)}
                                                  >
                                                    Edit
                                                  </Button>

             
              <Button
                                                     sx={{
                                                      backgroundColor: "#a82814",
                                                      color: "white",
                                                      "&:hover": { backgroundColor: "#7a1b0e" },
                                                      // borderRadius: 2,
                                                      padding: "4px 6px",
                                                    }}
                                                    onClick={() => handleDeleteClick(row)}
                                                  >
                                                    Delete
                                                  </Button>
                                                  </Box>
            </TableCell>
          </TableRow>
        ))
      )}
    </TableBody>
  </Table>
</TableContainer>



        {/* Dialog for editing */}
            <Dialog open={isDialogOpen} onClose={handleDialogClose}>
              <DialogTitle style={{ fontWeight: "bold"}}>Edit Driver and Attender Details</DialogTitle>
              <DialogContent>
              <Grid container spacing={2}>
  {/* Name */}
  {/* Bus Number */}
  <Grid item xs={6}>
    <TextField
      label="Bus Number"
      value={selectedRow ? selectedRow.busNumberPlate : ""}
      onChange={(e) =>
        setSelectedRow((prevState) => ({
          ...prevState,
          busNumberPlate: e.target.value,
        }))
      }
      fullWidth
      margin="normal"
      size="small"
      disabled
      InputProps={{
        style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
      }}
    />
  </Grid>

  {/* Route Number */}
  <Grid item xs={6}>
    <TextField
      label="Route Number"
      value={selectedRow ? selectedRow.routeNumber : ""}
      onChange={(e) =>
        setSelectedRow((prevState) => ({
          ...prevState,
          routeNumber: e.target.value,
        }))
      }
      fullWidth
      margin="normal"
      size="small"
      disabled
      InputProps={{
        style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
      }}
    />
  </Grid>

  {/* Pickup Location */}
  <Grid item xs={6}>
    <TextField
      label="Pickup Location"
      value={selectedRow ? selectedRow.driverPickupLocation : ""}
      onChange={(e) =>
        setSelectedRow((prevState) => ({
          ...prevState,
          driverPickupLocation: e.target.value,
        }))
      }
      fullWidth
      margin="normal"
      size="small"
       disabled
      InputProps={{
        style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
      }}
    />
  </Grid>

  {/* Drop Location */}
  <Grid item xs={6}>
    <TextField
      label="Drop Location"
      value={selectedRow ? selectedRow.driverDropLocation : ""}
      onChange={(e) =>
        setSelectedRow((prevState) => ({
          ...prevState,
          driverDropLocation: e.target.value,
        }))
      }
      fullWidth
      margin="normal"
      size="small"
       disabled
      InputProps={{
        style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
      }}
    />
  </Grid>

{/* //drivers */}
<Grid item xs={6}>
 <FormControl fullWidth size="small" margin="normal">
  <InputLabel>Select Driver</InputLabel>
  <Select
    value={selectedRow?.employeeId ?? ""}
    onChange={handleDriverChange}
    label="Select Driver"
    renderValue={(selected) => {
      // If selectedRow has a driver name, show it directly
      if (selectedRow?.firstName || selectedRow?.lastName) {
        return `${selectedRow.firstName || ""} ${selectedRow.lastName || ""}`.trim();
      }

      // Fallback: look up driver in driver list by employeeId
      const driverItem = driver.find((d) => d.employeeId === selected);
      return driverItem
        ? `${driverItem.firstName} ${driverItem.lastName}`
        : "";
    }}
  >
    {/* Option to clear driver */}
    <MenuItem value="">
      <em>None</em>
    </MenuItem>

    {/* If selected driver is not in driver list, show it explicitly */}
    {selectedRow?.employeeId &&
      !driver.some((d) => d.employeeId === selectedRow.employeeId) && (
        <MenuItem value={selectedRow.employeeId}>
          {`${selectedRow.employeeId} - ${selectedRow.firstName || ""} ${selectedRow.lastName || ""} (Assigned Driver)`}
        </MenuItem>
      )}

    {/* Render list of drivers */}
    {driver.length > 0 ? (
      driver.map((emp) => (
        <MenuItem key={emp.employeeId} value={emp.employeeId}>
          {`${emp.employeeId} - ${emp.firstName} ${emp.lastName}`}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No drivers available</MenuItem>
    )}
  </Select>
</FormControl>

</Grid>





{/* //attender list */}
<Grid item xs={6}>
<FormControl fullWidth size="small" margin="normal">
  <InputLabel>Select Attendant</InputLabel>
  <Select
    value={selectedRow?.attenderId || ""}
    onChange={(event) => {
      const selectedEmployeeId = event.target.value;

      if (selectedEmployeeId === "") {
        // User chose "None" -> clear attendant details
        setSelectedRow((prevData) => ({
          ...prevData,
          attenderId: "",
          attenderName: "",
          attendantMobile: "",
        }));
        return;
      }

      const selectedAttendant = attender.find(
        (emp) => emp.employeeId === selectedEmployeeId
      );

      if (selectedAttendant) {
        setSelectedRow((prevData) => ({
          ...prevData,
          attenderId: selectedAttendant.employeeId || "",
          attenderName: `${selectedAttendant.firstName} ${selectedAttendant.lastName}` || "",
          attendantMobile: selectedAttendant.mobileNo || "",
        }));
      }
    }}
    label="Select Attendant"
    renderValue={(selected) => {
      // Priority 1: If selectedRow.attenderId matches an attendant in the list, show their name
      const attendantFromList = attender.find(
        (a) => a.employeeId === selectedRow?.attenderId
      );
      if (attendantFromList) {
        return `${attendantFromList.firstName} ${attendantFromList.lastName}`;
      }

      // Priority 2: Show selectedRow.attenderName if it exists
      if (selectedRow?.attenderName) return selectedRow.attenderName;

      // Otherwise: empty
      return "";
    }}
  >
    {/* Option to clear attendant */}
    <MenuItem value="">
      <em>None</em>
    </MenuItem>

    {attender.length > 0 ? (
      attender.map((emp) => (
        <MenuItem key={emp.employeeId} value={emp.employeeId}>
          {`${emp.employeeId} - ${emp.firstName} ${emp.lastName}`}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No attendants available</MenuItem>
    )}
  </Select>
</FormControl>



</Grid>


{/* teacher list */}
<Grid item xs={6}>
 <FormControl fullWidth size="small" margin="normal">
  <InputLabel>Select Teacher</InputLabel>
  <Select
    value={selectedRow?.teacherId || ""}
    onChange={(event) => {
      const selectedTeacherId = event.target.value;
      const selectedTeacher = teachers.find(
        (emp) => emp.teacherId === selectedTeacherId
      );

      if (selectedTeacher) {
        setSelectedRow((prevData) => ({
          ...prevData,
          teacherId: selectedTeacher.teacherId || "",
          teacherName: `${selectedTeacher.teacherFirstName} ${selectedTeacher.teacherLastName}` || "",
          teacherMobileNumber: selectedTeacher.teacherMobileNumber || "",
        }));
      } else {
        // Clear teacher if none selected
        setSelectedRow((prevData) => ({
          ...prevData,
          teacherId: "",
          teacherName: "",
          teacherMobileNumber: "",
        }));
      }
    }}
    label="Select Teacher"
    renderValue={(selected) => {
      // Priority 1: If selectedRow.teacherId matches a teacher, show teacher's name from the list
      const teacherFromList = teachers.find(
        (t) => t.teacherId === selectedRow?.teacherId
      );
      if (teacherFromList) {
        return `${teacherFromList.teacherFirstName} ${teacherFromList.teacherLastName}`;
      }

      // Priority 2: If teacherName exists in selectedRow, show it
      if (selectedRow?.teacherName) return selectedRow.teacherName;

      // Otherwise: empty string
      return "";
    }}
  >
    {/* Option to clear teacher */}
    <MenuItem value="">
      <em>None</em>
    </MenuItem>

    {/* Render list of teachers */}
    {teachers.length > 0 ? (
      teachers.map((emp) => (
        <MenuItem key={emp.teacherId} value={emp.teacherId}>
          {`${emp.teacherId} - ${emp.teacherFirstName} ${emp.teacherLastName}`}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No teachers available</MenuItem>
    )}
  </Select>
</FormControl>

</Grid>






</Grid>

</DialogContent>

              <DialogActions>
              <Button
      onClick={handleDialogClose}
      color="primary"
      variant="outlined"
      
    >
      Cancel
    </Button>
    
    <Button
      onClick={handleSaveChanges}
      color="primary"
      variant="contained"
      disabled={dialogbtnloading} // Disable when loading
      sx={{
        fontWeight: 600,
        backgroundColor: "#3C3972",
        "&:hover": { backgroundColor: "#3C3972" },
      }}
      
    >
      {dialogbtnloading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Save"}
    </Button>
    
              </DialogActions>
            </Dialog>


        <ToastContainer position="top-right" autoClose={1000}  />
      </CardContent> 
    </Card>
  );
}

export default DriversList;